import React from 'react'
import { Block } from './Block'
import ImageBlockStyles from './ImageBlock.styles'

/**
 * Works with the core/gallery WordPress block.
 */
export class ImageBlock extends Block {
  constructor(block) {
    super(block)
    /**
     * Remove unneccessary parent 'div' by setting
     * the child 'figure' as the root component.
     */
    this.setElementAsRoot('figure')
  }

  render(props = {}) {
    return <ImageBlockStyles {...props}>{this.rootElement}</ImageBlockStyles>
  }
}

/**
 * core/image html:
	<div class="wp-block-image">
		<figure class="alignright size-full is-resized">
      <span class="wp-image-142186 inline-gatsby-image-wrapper gatsby-image-wrapper" style="" data-reactroot="">
				<span aria-hidden="true" style=""></span>
				<img aria-hidden="true" src="data:image/jpeg;base64,..." alt=""style="" />
				<picture>
					<source srcset="" sizes="" />
						<img sizes="" srcset="" src="" alt="" loading="eager" style="" />
				</picture>
				<noscript>
					<picture>
						<source srcset="" sizes="(max-width: 380px) 100vw, 380px" />
						<img loading="eager" sizes="" srcset="" src="" alt="" style="" />
					</picture>
				</noscript>
			</span>
			<figcaption>"Caption"</figcaption>
		</figure>
	</div>
 */
